<template>
  <div class="app-menu">
    <div class="menu-wrap">
      <button class="menu-item" :class="{ on: currentPath === '/app/main' }" @click="goToPage('app-main-view')">
        <div class="icon-box">
          <img class="off" :src="getAssetImageUrl('common/icons/home.svg')" alt="home" />
          <img class="on" :src="getAssetImageUrl('common/icons/home-on.svg')" alt="home-on" />
        </div>
        <span>{{ t('label_home') }}</span>
      </button>

      <div class="menu-item center-item">
        <div class="menu-primary-btn-wrap">
          <button type="button" class="main-btn" @click="openChatTypePopup">
            <AnimationAiWhite />
          </button>
          <div class="curve-bg"></div>
        </div>
        <span>{{ t('label_interpretation') }}</span>
      </div>

      <button class="menu-item" :class="{ on: currentPath === '/app/chats' }" @click="goToPage('app-chat-list')">
        <div class="icon-box">
          <img class="off" :src="getAssetImageUrl('common/icons/favorite.svg')" alt="" />
          <img class="on" :src="getAssetImageUrl('common/icons/favorite-on.svg')" alt="" />
        </div>
        <span>{{ t('favorite_interpretation_list') }}</span>
      </button>
    </div>

    <div class="menu-bg">
      <img :src="getAssetImageUrl('app/deco/menu-bg.svg')" alt="" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BottomSheet from '@/components/domains/mobile/common/PopupBottomSheet.vue';
import PopupSelectChat from '@/components/domains/mobile/popup/PopupSelectChat.vue';
import AnimationAiWhite from '@/components/jh-app/icons/AnimationAiWhite.vue';
import { usePopupStore } from '@/stores/popup';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const popupStore = usePopupStore();

const currentPath = computed(() => {
  return route.path;
});

const openChatTypePopup = () => {
  popupStore.open(BottomSheet, {
    title: t('select_interpreter'),
    contentSlot: h(PopupSelectChat),
    showHandleBar: true,
  });
};

const goToPage = (pageName: string) => {
  const query = pageName === 'app-chat-list' ? { tab: 'favorite' } : {};

  router.push({ name: pageName, query });
};
</script>

<style scoped lang="scss">
.app-menu {
  // position: fixed;
  position: relative;
  flex: 0 0 auto;
  z-index: $z-header;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom, 3rem);
  // bottom: var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px));
  background: #fff;
  &::before {
    content: '';
    position: absolute;
    bottom: -40px;
    background: #fff;
    width: 100%;
    height: 100%;
  }
  .menu-bg {
    position: fixed;
    width: 100vw;
    min-width: 400px;
    height: 87.5px;
    bottom: env(safe-area-inset-bottom, 3rem);
    left: calc(50%);
    transform: translateX(-50%);
    z-index: 1;

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: contain;
      bottom: 0;
    }
  }

  .menu-wrap {
    background: #fff;
    display: flex;
    height: 60px;
    justify-content: space-between;
    padding: 0 1.25rem;
    gap: 1.25rem;
    border-top: 1px solid $color-gray-40;

    .menu-item {
      width: 100%;
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      gap: $size-xs;
      padding: 0.75rem 0;
      z-index: 2;
      .icon-box {
        position: relative;
        width: 24px;
        height: 24px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          &.on {
            display: none;
          }
        }
      }
      span {
        font-size: $font-size-psmaller;
        font-weight: 600;
        color: $color-gray-90;
        line-height: 100%;
      }
      &.on {
        .icon-box {
          img {
            &.off {
              display: none;
            }
            &.on {
              display: block;
            }
          }
        }
        span {
          color: $color-gray-900;
        }
      }
    }
    .center-item {
      position: relative;
      overflow: visible;
      .menu-primary-btn-wrap {
        position: absolute;
        top: -23px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        .main-btn {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: $color-navy-100;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          position: relative;
        }
        img {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }
      }
      span {
        margin-top: 30px;
        color: $color-navy-100;
        font-weight: 700;
      }
    }
  }
  a {
    text-decoration: none;
  }
}
</style>
